import { KeywordValidation } from '../types';

const initKeywordValid: KeywordValidation = {
  Title: { isErr: false, errMsg: '', canNotSave: true },
};

export const loadedKeywordValid: KeywordValidation = {
  Title: { isErr: false, errMsg: '', canNotSave: false },
};

export default initKeywordValid;
